/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChoiceRadial/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromFlow from 'Simple/Flow'
import CheckSelected from 'DesignSystem/Svgs/CheckSelected/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ChoiceRadial({
  children,
  viewPath = "/DesignSystem/ChoiceRadial",
  backgroundColor = "#ffffff",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderColor = "#f2f2f2",
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  isDisabled,
  onClick,
  paddingBottom = 8,
  paddingLeft = 15,
  paddingTop = 8,
  width = 100,
  isSelected,
  backgroundColorSelected = "rgba(0,188, 112, 0.1)",
  borderColorSelected = "rgba(0,188, 112, 0.0)",
  borderColorHovered = "rgba(0,188, 112, 0.7)",
  alignSelf = "center",
  color = "#303030",
  text = "",
  colorSelected = "#303030",
  colorHovered = "rgba(0,188, 112, 1)",
  stroke
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="ChoiceRadial.ChoiceRadial:1"
  data-view-path={viewPath}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-ZLDt9k': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-ZLDt9k': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-ZLDt9k': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-ZLDt9k': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--ml-7-ZLDt9k': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-8-ZLDt9k': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-9-ZLDt9k': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-10-ZLDt9k': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-11-ZLDt9k': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pt-12-ZLDt9k': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-13-ZLDt9k': typeof width === 'number' ? `${width}px` : width,'--bc-1-ZLDt9k': isSelected ? backgroundColorSelected : backgroundColor,'--bc-4-ZLDt9k': isSelected ? borderColorSelected : isHovered ? borderColorHovered : borderColor}}
 className={`views-block ${styles.ChoiceRadial1}`}
>
<span
  data-testid="ChoiceRadial.Text"
  data-view-path={viewPath}
 style={{'--as-14-ZLDt9k': alignSelf,'--c-15-ZLDt9k': isSelected ? colorSelected : isHovered ? colorHovered : color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<div
  data-testid="ChoiceRadial.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isSelected}>
<CheckSelected
  viewPath={`${viewPath}/CheckSelected`}
 stroke={stroke}
/>
</fromFlow.When>
</div>
</button>
{children}
</React.Fragment>)
}